import style from './OptionsSelection.module.scss';
import { useEffect, useState, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import useOutsideAlerter from 'helpers/useOutsideAlerter';

const OptionsSelection = ({ label, options, selected, placeholder, multi, setSelected }) => {
    const [ menuOpen, setMenuOpen ] = useState(false);
    const selectionRef = useRef(null);
    const isOpenRef = useRef(null);

    useOutsideAlerter(selectionRef, () => {
        if(isOpenRef.current ) {
            setMenuOpen(false);
        }
    })

    const handleSeleciton = (option) => {

        if (!multi) {
            setMenuOpen(false)
            setSelected(option)
        } else {
            const selection = Array.isArray(selected) ? [ ...selected ] : [];

            if (selection.includes(option)) {
                selection.splice(selection.indexOf(option), 1)
            } else {
                selection.push(option)
            }

            setSelected(selection)
        }
    }

    const getSelectedLabel = () => {
        if (selected !== undefined && selected !== null && selected?.length !== 0) {
            if (multi) {
                return <div className={style.multiSelection}>
                    {selected.map((option, i) => {
                        return (<span key={i} className={style.selectedItem}>{option.label}</span>)
                    })}
                </div>
            } else {
                return selected.label
            }
        } else {
            //return <span className={style.placeholder}>{placeholder}</span>
        }
    }

    useEffect(() => {
        isOpenRef.current = menuOpen;
    }, [menuOpen])

    const selectedLabel = getSelectedLabel();

    return (<div ref={selectionRef} className={ !menuOpen ? style.optionSelection : [ style.optionSelection, style.menuOpen ].join(' ') }>
        <div onClick={ (e) => {
        setMenuOpen(!menuOpen)
    } } className={ style.selectedOption }>
            <div className={selectedLabel !== null && selectedLabel !== undefined ? style.hasSelection : style.noSelection}>
                {label && <label>{label}</label>}
                <div className={style.selectedValue}>{ selectedLabel }</div>
            </div>
            <div className={ style.selectionArrow }>
                <FaChevronDown />
            </div>
        </div>
        <div className={ style.optionsMenu }>
            { options.map((o, i) => {
                const isSelected = multi ? (Array.isArray(selected) && selected.includes(o)) : selected?.id == o.id;
                const showOption = !multi && isSelected ? false : true;
                return (
                    <>
                        { showOption && <div key={ i } onClick={ (e) => {
                            handleSeleciton(o);
                        } } className={ [ style.option, isSelected && style.selected ].join(' ') }>
                            <div className={ style.optionIcon }>
                            </div>
                            <div className={ style.optionText }>
                                { o.label }
                            </div>
                        </div> }
                    </>
                )
            }) }
        </div>
    </div>)
}

export default OptionsSelection;